var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeeProduceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.893,
    height: 82.928,
    viewBox: "0 0 77.893 82.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.848 -7.538)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 17.356,
    x2: 8.124,
    transform: "translate(49.288 9.78)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.124,
    y1: 17.356,
    transform: "translate(34.664 9.78)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.513,68.973a10.066,10.066,0,0,1-2.47.3,9.747,9.747,0,0,1-6.48-17.03c1.72-1.54,21.1-13.84,21.1-13.84",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.233,38.913c3.71,2.37,18.77,11.98,20.28,13.33a9.747,9.747,0,0,1-6.48,17.03c-4.83,0-8.85-3.3-9.75-6.57",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.813,61.673a33.072,33.072,0,0,1,.33-3.77c.36-2.58.92-4.73,1.26-6.47.01-.06,3.26-13.03,3.26-13.03.91-5.61,3.52-9.54,7.85-10.87a12.676,12.676,0,0,1,7.05,0c3.37,1.04,5.7,3.65,6.99,7.4",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.134,41.1c.77,3.1,2.519,10.288,2.539,10.338.34,1.74.9,3.89,1.26,6.47a33.583,33.583,0,0,1,.35,4.8,20.8,20.8,0,0,1-.49,4.95c-.71,2.86-2.16,4.55-4.38,6.5-.46.4-11.38,9.75-11.38,9.75s-10.91-9.35-11.37-9.75c-2.22-1.95-3.67-3.64-4.38-6.5",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.874,
    transform: "translate(44.413 57.901)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("line", {
    x2: 17.874,
    transform: "translate(44.413 67.651)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.749,
    transform: "translate(29.789 67.651)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("line", {
    x2: 6.5,
    transform: "translate(33.039 48.152)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.66,
    transform: "translate(51.377 48.152)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("line", {
    y1: 73.65,
    x2: 73.65,
    transform: "translate(8.969 14.694)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeProduceIcon);
export default __webpack_public_path__ + "static/media/bee-produce-icon.42385785.svg";
export { ForwardRef as ReactComponent };